import type { FeatureDefinitionGroup } from '../feature-definition-types';

export type MessagesRelativePath = '/inbox' | '/scheduled' | '/drafts' | '/archived' | '/blocked';

export const featureDefinition = {
  root: '/messages',
  iconName: 'inbox',
  items: {
    '/inbox': {
      label: 'Inbox',
      trackingId: 'nav-messages-inbox',
      description:
        'Central hub for all incoming text messages and outgoing text messages. View, read, and respond to real-time patient and customer communications.',
    },
    '/scheduled': {
      label: 'Scheduled',
      trackingId: 'nav-messages-scheduled',
      description:
        'Displays all messages that are set for future delivery, with options to edit or cancel before sending.',
    },
    '/drafts': {
      label: 'Drafts',
      trackingId: 'nav-messages-drafts',
      description: 'Holds incomplete or unsent messages. Drafts can be edited, scheduled, or sent immediately.',
    },
    '/archived': {
      label: 'Archived',
      trackingId: 'nav-messages-archived',
      description:
        'A read-only storage of older messages that have been removed from the active inbox, preserving past communication history.',
    },
    '/blocked': {
      label: 'Blocked',
      trackingId: 'nav-messages-blocked',
      description:
        'Lists blocked contacts and message threads, preventing further incoming messages from specific numbers or addresses.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/messages', 'inbox', MessagesRelativePath>;
